import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import VVSTable from "components/form-control/VVSTable";
import SelectField from "components/form-control/Select";
import { useForm } from "react-hook-form";
import moment from "moment";

const FILTER_CONTRACT_OPTIONS = [
  { index: 1, name: "Tất cả", value: "all" },
  { index: 2, name: "Sắp hết hạn", value: "expirationSoon" },
  { index: 3, name: "Đã hết hạn", value: "expired" },
  { index: 4, name: "Đang hiệu lực", value: "effective" },
  { index: 5, name: "Đã thanh lý", value: "completed" },
];

export default function Contract() {
  const [filter, setFilter] = useState("");
  const { register } = useForm({});

  const getFilterData = type => {
    if (type === "expirationSoon") {
      const startDate = moment(new Date(), "DD-MM-YYYY");
      const endDate = moment(new Date(), "DD-MM-YYYY").add(14, "days");
      return {
        endDate: {
          $gte: {
            __type: "Date",
            iso: startDate,
          },
          $lte: {
            __type: "Date",
            iso: endDate,
          },
        },
      };
    }
    if (type === "expired") {
      const startDate = moment(new Date(), "DD-MM-YYYY");
      return {
        endDate: {
          $lte: {
            __type: "Date",
            iso: startDate,
          },
        },
      };
    }
    if (type === "completed") {
      return {
        status: "completed",
      };
    }
    if (type === "effective") {
      return {
        status: "effective",
      };
    }
  };

  useEffect(() => {
    if (filter?.target?.value) {
      getFilterData(filter?.target?.value);
    }
  }, [filter?.target?.value]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row
            style={{
              position: "relative",
              marginBottom: "-35px",
              zIndex: 99,
              width: "max-content",
            }}
          >
            <h4 className="my-0 font-size-18 text-capitalize mb-2">
              Hợp đồng đầu tư
            </h4>
            <Col>
              <SelectField
                name="filter"
                options={FILTER_CONTRACT_OPTIONS}
                register={register}
                onChange={setFilter}
              />
            </Col>
          </Row>
          <VVSTable
            name="Contract"
            disableAdd
            whereQuery={getFilterData(filter?.target?.value)}
            showExportExcel
            pointer="Customer"
          />
        </Container>
      </div>
    </React.Fragment>
  );
}
